export default "__VITE_ASSET__Bxsgnz3K__"